var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlayIcon = function SvgPlayIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.066,
    height: 52.066,
    viewBox: "0 0 52.066 52.066",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play_Icon",
    "data-name": "Play Icon",
    transform: "translate(-46.967 -29.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(46.967 29.967)",
    fill: "rgba(0,0,0,0.35)",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.033,
    cy: 26.033,
    r: 26.033,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.033,
    cy: 26.033,
    r: 24.533,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M0,0,21.074,14.076h0L0,27.686Z",
    transform: "translate(65.562 42.364)",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "play-icon.e3640311da2bbc2bab7354a7217b5080.svg";